import { render, staticRenderFns } from "./attributePoolModal.vue?vue&type=template&id=4d241af2&scoped=true"
import script from "./attributePoolModal.vue?vue&type=script&lang=js"
export * from "./attributePoolModal.vue?vue&type=script&lang=js"
import style0 from "./attributePoolModal.vue?vue&type=style&index=0&id=4d241af2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d241af2",
  null
  
)

export default component.exports